<template>
    <div class="wrapper bg-secondary py-16 px-10 rounded-lg relative">
        <div v-if="!enabled" class="overlay absolute bg-white opacity-50 w-full h-full -mx-10 -my-16 z-20"></div>
        <swiper ref="mySwiper" :options="swiperOptions" :navigation="true" @slideChange="updateValue" @ready="ready">
            <swiper-slide v-for="date, i in values" :key="i"><div class="text-xl">{{ date | moment('D MMM') }}</div></swiper-slide>
        </swiper>        
        <a href="#" @click="prev()" class="absolute left-4 top-2/4 transform -translate-y-2/4 center text-primary" v-if="value > min">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
        </a>
        <a href="#" @click="next()" class="absolute right-4 top-2/4 transform -translate-y-2/4 center text-primary" v-if="value < max">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
        </a>
        <div class="absolute right-2/4 top-2/4 transform -translate-y-2/4 translate-x-2/4 w-20 h-14 bg-primary shadow-lg z-10 rounded-lg text-center">
            <span class="text-white text-xl py-3 font-bold block">{{ value | moment('D MMM') }}</span>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
    name: 'carrousel',
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    props: {
        min: {type: Object, required: true }, 
        max: {type: Object, required: true}, 
        value: {type: Date, default: new Date()}, 
        enabled: {type: Boolean, default: true}
    },
    data() {
        return {
            swiperOptions: {
                slidesPerView: window.innerWidth > 1024 ? 5 : 3,
                loop: false,
                centeredSlides: true
            }
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        },
        values() {
            let start = new this.$moment(this.min)
            let values = []
            while(start < this.max) {
                values.push(start)
                start = (new this.$moment(start)).add(1, 'days')                
            }            
            return values            
        }
    },
    methods: {
        prev() {            
            if(this.enabled) this.swiper.slidePrev()
        },
        next() {            
            if(this.enabled) this.swiper.slideNext()
        },
        ready() {            
            const delta = (new this.$moment(this.value)).diff(new this.$moment(this.min), 'days')            
            this.swiper.slideTo(delta, 0, false)
        },
        updateValue() {    
            this.$emit('change', this.values[this.swiper.realIndex].toDate())
        }
    }
}
</script>